import React, { useState } from 'react';
import { Menu, Dropdown, Button, Popconfirm } from 'antd';
import { Container, Menus } from './styles';
import { LoadingOutlined, TableOutlined } from '@ant-design/icons';
import ExcelJS from "exceljs";
import { IAgendamentos } from 'store/ducks/agendamentos/types';
import mask from 'utils/mask';
import moment from "moment"
import { saveAs } from 'file-saver';
import { AgendamentoServices } from 'modules/agendamentos/submodules/agendamentos/services/AgendamentoServices';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';

export const Export: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth.cddAtivo);
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const pagination = useSelector((state: ApplicationState) => state.Agendamentos.pagination);
  const agendamentos = useSelector((state: ApplicationState) => state.Agendamentos.data);
  
  const getAllAgendamentos = async () => {
    const { data } = await AgendamentoServices.getAllData(
      cddAtivo?.codCdd,
      {},
      inscricaoAtiva,
      pagination.total
    );
    return data.agendamentos;
  }

  const handleExport = async (
    type: "xlsx" | "csv",
    quantity: "current" | "all",
    schedulling: IAgendamentos[],
    getAllData: () => Promise<IAgendamentos[]>
  ) => {
    setLoading(true);
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("Relatório de agendamentos");
    let buffer;

    sheet.columns = [
      { header: "Cód. Agendamento", key: "codAgendamento", },
      { header: "Tipo [WMS]", key: "tipoWms", },
      { header: "Nome Parceiro (Transportadora)", key: "transportadora", },
      { header: "Placa", key: "placa", },
      { header: "Descrição (Tipo Carroceria)", key: "tipoCarroceria", },
      { header: "Data e hora do agendamento", key: "dhAgendamento", },
      { header: "Data/Hora da chegada", key: "dhChegada", },
      { header: "Data/Hora da entrada", key: "dhEntrada", },
      { header: "Data/Hora de Saída", key: "dhSaida", },
    ]

    sheet.getRow(1).font = { bold: true, size: 12, color: { argb: "000000" } }
    const data = quantity === "all" ? await getAllData() : schedulling;

    data?.map(sch => {
      sheet.addRow({
        codAgendamento: sch?.codAgendamento,
        tipoWms: sch?.tipoWms === "REC" ? "Recebimento" : sch?.tipoWms === "EXP" ? "Expedição" : "",
        transportadora: mask("camelCase", sch?.transportadora ?? ""),
        placa: sch?.placa?.toUpperCase(),
        tipoCarroceria: mask("camelCase", sch?.detalheVeiculo?.tipoCarroceria),
        dhAgendamento: sch?.dhAgendamento ? moment(sch?.dhAgendamento).format("DD/MM/YYYY HH:MM") : "",
        dhChegada: sch?.dhChegada ? moment(sch?.dhChegada).format("DD/MM/YYYY HH:MM") : "",
        dhEntrada: sch?.dhEntrada ? moment(sch?.dhEntrada).format("DD/MM/YYYY HH:MM") : "",
        dhSaida: sch?.dhSaida ? moment(sch?.dhSaida).format("DD/MM/YYYY HH:MM") : ""
      })
    })

    sheet.getRows(2, sheet.rowCount)?.forEach(row => {
      row.alignment = { horizontal: "center" }
      row.font = { size: 11 }
    })

    sheet.columns.forEach((column) => {
      if (!column) return;
      if (typeof column.eachCell !== "function") return;

      let minLength = 10;
      column.eachCell({ includeEmpty: true }, (cell) => {
        const value = cell.value ? cell.value.toString() : "";
        if (value.length > minLength) {
          minLength = value.length;
        }
      });
      column.width = minLength + 4;

    });
    

    if (type === "xlsx") {
      buffer = await workbook.xlsx.writeBuffer();
    } else {
      const csvBuffer = await workbook.csv.writeBuffer();
      const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
      const combined = new Uint8Array(bom.length + csvBuffer.byteLength);
      combined.set(bom, 0);
      combined.set(new Uint8Array(csvBuffer), bom.length);
      buffer = combined.buffer;
    }

    const file = saveAs(new Blob([buffer]), type === "xlsx" ? "relatorio-agendamentos.xlsx" : "relatorio-agendamentos.csv")
    setLoading(false);
    return file;
  }

  const menuDropDown = (
    <Menus>
      <Menu.Item>
        <Popconfirm
          cancelButtonProps={{ type: 'primary' }}
          title={'Como deseja exportar?'}
          okText="Somente a página atual"
          cancelText="Todas as páginas"
          placement="leftTop"
          onConfirm={() => handleExport("xlsx", 'current', agendamentos, getAllAgendamentos)}
          onCancel={() => handleExport("xlsx", 'all', agendamentos, getAllAgendamentos)}
        >
          <Button type="link">XLS - Excel</Button>
        </Popconfirm>
      </Menu.Item>

      <Menu.Item>
        <Popconfirm
          cancelButtonProps={{ type: 'primary' }}
          title={'Como deseja exportar?'}
          okText="Somente a página atual"
          cancelText="Todas as páginas"
          placement="leftTop"
          onConfirm={() => handleExport("csv", 'current', agendamentos, getAllAgendamentos)}
          onCancel={() => handleExport("csv", 'all', agendamentos, getAllAgendamentos)}
        >
          <Button type="link">
            CSV
          </Button>
        </Popconfirm>
      </Menu.Item>
    </Menus>
  );

  return (
    <Dropdown disabled={loading} overlay={menuDropDown}>
      <Container
        className="outlineBtn"
        icon={loading ? <LoadingOutlined /> : <TableOutlined />}
        onClick={(e) => e.preventDefault()}
      >
        {loading ? 'Aguarde...' : 'Exportar'}
      </Container>
    </Dropdown>
  );
};
